// extracted by mini-css-extract-plugin
module.exports = {"contacts":"page_contacts__Ltl8g"};